import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class SponsorsService {

  constructor(private http:HttpClient) { }

  addSponsors(data) {
    return this.http.post(`${API_URL}sponsors`,data);
  }

  updateSponsors(id,data) {
    return this.http.put(`${API_URL}sponsors/${id}`,data);
  }

  getSponsorsById(id:string) {
    return this.http.get(`${API_URL}sponsors/${id}`);
  }

  getSponsors(query:string) {
    return this.http.get(`${API_URL}sponsors${query}`);
  }
}


